import { render } from "./ReceiversTable.vue?vue&type=template&id=414f7f2a"
import script from "./ReceiversTable.vue?vue&type=script&lang=js"
export * from "./ReceiversTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__